import type { QuestionData } from 'src/types/formQuestionnaire';
import { collapseWhitespace } from './validation';

export function isQuestionCountedForPublish(question: QuestionData): boolean {
  return (
    collapseWhitespace(question.questionText) !== '' &&
    Boolean(question.questionType)
  );
}
